import { Pipe, PipeTransform } from '@angular/core';
import { Learning_Type } from '@app/enums/learning-type.enum';

@Pipe({
  name: 'showCardSubHeaderTitle',
  standalone: false,
})
export class ShowCardSubHeaderTitlePipe implements PipeTransform {
  /**
   * Return transformed learning type string to new display call to action for unsigned
   * or user that is not logged in
   * @param learningType - learning type to transform to new display type
   * @param isFreeCourse - Is Free course if the course IsFreeCourse additional field from course is true, else false.
   * @param cardType - Optional Course title, if any there is any title string
   * @returns - transformed call to action string to show if course or subscription is free
   */
  public transform(learningType: string, isFreeCourse: boolean): string {
    switch (learningType) {
      case Learning_Type.SUBSCRIPTION:
        return '';
      case Learning_Type.WEBINAR:
      case Learning_Type.E_LEARNING:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.CERTIFICATION_EXAM:
        if (isFreeCourse) {
          return 'FREE';
        } else {
          return '';
        }
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.SELF_STUDY:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
        return '';
      default:
        // Everything else like flexible_learning, upcoming_sessions, etc.. returns empty string
        return '';
    }
  }
}
